import {
  createStyles,
  makeStyles,
  TextField,
  Theme,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import React from "react";
import { Player } from "../store/types";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      margin: "14px 0",
      [theme.breakpoints.down("sm")]: {
        margin: "14px 14px",
      },
      "& .MuiInputBase-input": {
        backgroundColor: theme.palette.common.white,
        borderRadius: 12,
        padding: "6px !important",
        overflow: "hidden",
      },
      "& .MuiFormControl-root": {
        width: "100%",
        height: 60,
      },
      "& .MuiFilledInput-inputMarginDense": {
        paddingTop: 14,
        paddingBottom: 14,
      },
      "& .MuiAutocomplete-inputRoot": {
        backgroundColor: theme.palette.common.white,
        borderRadius: 12,
        height: "100%",
        fontSize: "1.125rem",
      },
      "& .MuiAutocomplete-listbox": {
        fontSize: "1.125rem",
      },
    },
  })
);

interface OwnProps {
  readonly players: Player[];
  readonly setPlayer: (player: string, prevPlayer: string) => void;
  readonly removePlayer: (player: string) => void;
  readonly loadedPlayer?: string;
  readonly unfilteredPlayers: Player[];
}

type Props = OwnProps;

const useWidth = () => {
  const theme = useTheme();
  const keys = [...theme.breakpoints.keys].reverse();
  return (
    keys.reduce((output: any, key: any) => {
      // eslint-disable-next-line react-hooks/rules-of-hooks
      const matches = useMediaQuery(theme.breakpoints.up(key));
      return !output && matches ? key : output;
    }, null) || "xs"
  );
};

const PlayerInput = (props: Props) => {
  const classes = useStyles();
  const { players, loadedPlayer, unfilteredPlayers, setPlayer, removePlayer } =
    props;
  const [selectedPlayer, setSelectedPlayer] = React.useState("");
  const width = useWidth();

  React.useEffect(() => {
    setSelectedPlayer(loadedPlayer || "");
    if (players.length > 0 && loadedPlayer) {
      setPlayer(loadedPlayer || "", "");
    }
  }, [loadedPlayer]);

  return (
    <div className={classes.root}>
      <Autocomplete
        value={unfilteredPlayers.find((p) => p.id === selectedPlayer) || null}
        blurOnSelect
        disablePortal={["xs"].indexOf(width) >= 0 ? false : true}
        options={players}
        getOptionLabel={(option) => `${option.displayText}`}
        renderInput={(params) => (
          <TextField {...params} placeholder="Search for a Player" />
        )}
        onChange={(e, value, reason) => {
          if (reason === "select-option") {
            setPlayer(value?.id || "", selectedPlayer);
            setSelectedPlayer(value?.id || "");
          }
          if (reason === "clear") {
            removePlayer(selectedPlayer);
            setSelectedPlayer("");
          }
        }}
      />
    </div>
  );
};

export default PlayerInput;
